import { getPercentageLocalKeyFromPrimaryKey } from '../metrics/metricHelpers';
import { get, isEmpty } from 'lodash';
import moment from 'moment';

function calcPercentage(total, value) {
  const pct = (value / total) * 100;
  return isNaN(pct) || !isFinite(pct) ? 'NA' : pct;
}

export function addLocalPercentageMetrics(metrics, rows, totals) {
  try {
    if (!isEmpty(rows) && !isEmpty(totals)) {
      metrics.forEach((metric) => {
        const localPctMetric = getPercentageLocalKeyFromPrimaryKey({ metricKey: metric });

        if (localPctMetric && metric in totals) {
          const totalZero = totals[metric] === 0;
          const totalNA = totals[metric] === 'NA';
          rows.forEach((row) => {
            if (totalZero || totalNA) {
              row[localPctMetric] = totals[metric];
            } else {
              row[localPctMetric] = calcPercentage(totals[metric], row[metric]);
            }
          });
          if (totalZero || totalNA) {
            totals[localPctMetric] = totals[metric];
          } else {
            totals[localPctMetric] = 100;
          }
        }
      });
    }
  } catch (err) {
    console.log('percentage calculation failed', err);
  }
}


export function flattenData(res, query) {
  const { data: _data, totals: _totals } = get(res, ['0'], {});
  const totals = get(_totals, ['0', 'results']);
  const rows = get(_data, ['0', 'results']);

  const adjustedInterval = get(
    res,
    '[0].annotations[0].value',
    `${moment().format()}/${moment().format()}`,
  );
  addLocalPercentageMetrics(query.metrics, rows, totals);
  return { totals, rows, adjustedInterval };
}
